import ItemSubcont from './RegistrasiSubkon';

export default ItemSubcont;
